import { render, staticRenderFns } from "./red_talent_index.vue?vue&type=template&id=a52c3db4&scoped=true"
import script from "./red_talent_index.vue?vue&type=script&lang=js"
export * from "./red_talent_index.vue?vue&type=script&lang=js"
import style0 from "./red_talent_index.vue?vue&type=style&index=0&id=a52c3db4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52c3db4",
  null
  
)

export default component.exports